var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"switch"},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox","disabled":_vm.isDisable},domProps:{"checked":_vm.isChecked},on:{"click":function($event){return _vm.clickHandler($event)}}}),_vm._v(" "),_c('span',{staticClass:"switch-label"}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f98b79e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partials/ToggleButton.vue
// module id = 1888
// module chunks = 0